/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './Multiaxis.css';

import CustomChart from '../../../components/CustomChart'
import { multiaxis } from '../../../chart';
import { CustomizedForm } from '../components/baseForm'
import baseFiled from '../components/baseFiled';
import MultiaxisPane from '../components/Multiaxis'
import { isArray } from 'util';

const checkPx = (str) => {
  let _str = str + '';
  if (_str.indexOf('%')) {
    return _str;
  } else {
    return _str + 'px'
  }
}

const colorList = [{
  name: '左侧纵坐标',
  value: 'yLeft',
  color: '#ffd70d'
}, {
  name: '右侧纵坐标',
  value: 'yRight',
  color: '#bfbebf'
}]

const createListItem = (list, name, value) => {
  let dataListItem = {
    name: name || ''
  }
  list.forEach(element => {
    dataListItem[element.value] = value||0
  });
  return dataListItem
}

class IndustryContent extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      fields: {
        ...Object.assign(baseFiled, {
          titleText: {
            value: 'Apple、华为、三星内容条数对比'
          },
          subTitleText: {
            value: '2019.11.01-2019.11.10'
          }
        })
      },
      axis: 'horizontal',
      list: [],
      labelList: [],
      colorList,
      chartWidth: '100%',
      chartHeight: '100%',
      chart: multiaxis(),
    }

    this.handleFormChange = this.handleFormChange.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    const d = [{"name":"2019.11.01","agreeable":"2037","neutrality":"5659"},{"name":"2019.11.02","agreeable":"5276","neutrality":"3309"},{"name":"2019.11.03","agreeable":"2851","neutrality":"4059"},{"name":"2019.11.04","agreeable":"4819","neutrality":"2519"},{"name":"2019.11.05","agreeable":"5869","neutrality":"3945"},{"name":"2019.11.06","agreeable":"2458","neutrality":"1923"},{"name":"2019.11.07","agreeable":"3498","neutrality":"12418"},{"name":"2019.11.08","agreeable":"5832","neutrality":"3481"},{"name":"2019.11.09","agreeable":"5482","neutrality":"3757"},{"name":"2019.11.10","agreeable":"8471","neutrality":"2385"}]

    this.setState({
      list: d,
      labelList: [
        {xAxis:'2019.11.01','label':'标注111','yAxis':'1'},
        {xAxis:'2019.11.07','label':'标注222','yAxis':'0'}
      ]
    }, this.init)
  }

  init = () => {
    const {fields, list, colorList, axis, labelList} = this.state;
    const colors = createListItem(colorList) 
    const chart = multiaxis({
      ...fields,
      list,
      colorList,
      axis: axis,
      colors: Object.keys(colors),
      labelList
    });

    this.setState({
      chartHeight: checkPx(fields.chartHeight.value),
      chartWidth: checkPx(fields.chartWidth.value),
      chart: chart
    })
  }

  handleFormChange (props, changedFields) {
    this.setState(({ fields }) => ({
      fields: {
        ...fields,
        ...changedFields
      }
    }));
  }

  handleAdd (props, changedFields) {
    if (isArray(changedFields)) {
      this.setState({
        list: changedFields
      })
    } else {
      this.setState({
        ...changedFields
      })
    }
  }

  handleClick () {
    this.init()
  }

  render() {
    const {fields, list, colorList, chartWidth, chartHeight, chart, labelList} = this.state;

    return (
      <CustomChart width={chartWidth} height={chartHeight} chart={chart} callback={this.handleClick}>
        <MultiaxisPane list={list} color={colorList} labelList={labelList} onChange={this.handleAdd} />
        <CustomizedForm {...fields} onChange={this.handleFormChange} />
      </CustomChart>
    )
  }
}

export default withStyles(s)(IndustryContent);



// WEBPACK FOOTER //
// src/routes/customChart/Multiaxis/index.js